import { LinkDriveFolderDialog } from "@/components/folder/LinkDriveFolderDialog";
import { useState } from "react";
import { KitMenuTemplate } from "../KitMenuTemplate";
import { useFolderGroup } from "./hooks";
import { KitTypeMenuProps } from "./types";

export const RepositoryMenu: React.FC<KitTypeMenuProps> = ({
  mode,
  groupUuid,
  groupSlug,
  kit,
}) => {
  const [driveFolderDialog, setDriveFolderDialog] = useState(false);
  const folderGroup = useFolderGroup({
    groupUuid,
    kitUuid: kit.uuid,
    onLinkDriveFolderClick: () => setDriveFolderDialog(true),
  });

  const groups = [folderGroup];
  return (
    <>
      <KitMenuTemplate kit={kit} groups={groups} mode={mode} />
      <LinkDriveFolderDialog
        open={driveFolderDialog}
        onOpenChange={setDriveFolderDialog}
        groupUuid={groupUuid}
        groupSlug={groupSlug}
        kitUuid={kit.uuid}
      />
    </>
  );
};
